import React from "react";
import { connect } from "react-redux";

import { useNavigate } from "../../utils/components/router";
import Denominator from "../denominator/Denominator";
import BasketBaseItem from '../BasketBaseItem';
import { scrollToTop, scrollTo } from "../../utils/functions";

class BasketCurrenciesItem extends BasketBaseItem {
  constructor(props) {
    super(props);
    this.handleDenominationOpen = this.handleDenominationOpen.bind(this);
    this.handleDenominationClose = this.handleDenominationClose.bind(this);
  }

  handleDenominationOpen() {
    this.setState({ denominator: true, windowPosition: window.scrollY });
    scrollToTop();
  }

  handleDenominationClose() {
    scrollTo(this.state.windowPosition);
    this.setState({ denominator: false, windowPosition: null });
  }

  getItemPrice() {
    return this.props.item.price.clone();
  }

  renderItem() {
    let config = this.props.configStorage;
    let item = this.props.item;
    return (
      <>
        <td className="text-start" aria-label="Produkt">
          <span className="ser-value itemTitle">{item.name}</span>
          <div className="ps-2" aria-label="Produktinfo">
            <span className="f-small text-wrap">{item.produktInfo}</span>
          </div>
        </td>
        <td className="text-end redOnDirty" aria-label="Kurs">
          {item.getDisplayRate()}
        </td>
        <td className="text-end" aria-label="Betrag">
          {item.toIso()}
        </td>
        {!config.isAnkaufShop()
          ? (
            <td className="text-end column-1" aria-label="Stückelung">
              {item.hasSelectedDenomination
                ?
                <>
                  <button type="button"
                    className="ser-denomination btn-link"
                    onClick={this.handleDenominationOpen}
                  >
                    ansehen
                  </button>
                  <Denominator
                    item={item}
                    hidden={!this.state.denominator}
                    locked
                    onclose={this.handleDenominationClose}
                  />
                </>
                : "gemischt"
              }
            </td>
          )
          : null
        }
        {this.renderKonditionChange()}
        <td className="text-end redOnDirty" aria-label="Gegenwert inkl. Konditionsänderung/Gebühr">
          {item.positionSum.toEuro()}
        </td>
      </>
    );
  }
}

export default connect(store => {
  return {
    basketStorage: store.basketStorage, // used in BasketBaseItem
    configStorage: store.configStorage,
    rightStorage: store.rightStorage, // used in BasketBaseItem
  };
})((props) => {
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <BasketCurrenciesItem navigate={contextNavigate} {...props} />;
});
